import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import { withSelect, withDispatch } from '@wordpress/data'
import { PostTypeSupportCheck } from '@wordpress/editor'
import { BaseControl } from '@wordpress/components'
import { i18n } from 'cartzillagb'
import { PostTypeCheck, PostSelector } from '~cartzillagb/components'

const PostAdditionalMeta = props => {
	const { relatedPosts, setRelatedPosts } = props
  
	return(
		<PostTypeCheck name="post">
			<PostTypeSupportCheck supportKeys="post-formats">
				<BaseControl label={ __( 'Related Post', i18n ) } id={ "post" }>
					<PostSelector
						autoFocus={ false }
						onPostSelect={ post => {
							relatedPosts.push(post)
							setRelatedPosts( [...relatedPosts])
						} }
						posts={ relatedPosts }
						onChange={ newValue => {
							setRelatedPosts( [...newValue] )
						} }
						postType="post"
					/>
				</BaseControl>
			</PostTypeSupportCheck>
		</PostTypeCheck>
	)
}

export default compose(
	withSelect( select => {
		const { getEditedPostAttribute } = select( 'core/editor' )
        const meta = getEditedPostAttribute( 'meta' ) || {}
        const { _relatedPosts } = meta

		return {
			relatedPosts: _relatedPosts ? JSON.parse( _relatedPosts ) : [],
		}
	} ),
	withDispatch( dispatch => ( {
		setRelatedPosts( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _relatedPosts: JSON.stringify(value) } } )
		},
	} ) ),
)( PostAdditionalMeta )